













import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import WriterUserProfileInformation from '@/modules/user/components/writer/WriterUserProfileInformation.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    UserInformation: WriterUserProfileInformation,
    Heading
  }
})
export default class WriterInfoPage extends Vue {
  @Prop() info !: any
}
